import { Typography } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { deleteEvent } from '@/slices/events';
import { type DrawerContentProps } from '../../../state';
import { DrawerLayout } from '../../layouts';

type Props = DrawerContentProps & ConnectedProps<typeof connector>;

const DeleteEventDrawer = ({
  closeDrawer,
  drawerData: { page, propertyId, eventId },
  deleteEvent,
}: Props) => {
  const handleAccept = () => {
    deleteEvent({ page, propertyId, eventId });
    closeDrawer();
  };

  return (
    <DrawerLayout
      danger
      closeDrawer={closeDrawer}
      title="Delete Event"
      onAccept={handleAccept}
      acceptText="Delete"
      onCancel={closeDrawer}
      cancelText="Cancel"
    >
      <Typography>Are you sure you want to delete this event?</Typography>
    </DrawerLayout>
  );
};

const connector = connect(null, { deleteEvent });

export default connector(DeleteEventDrawer);
